module.exports = __webpack_public_path__ + "img/BetFury_logo_vertical_color_on_dark.630dcce.png";